import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { IStoreState, IVehicleFilters } from '../../types'
import AssignOperatorVehicle from '../../components/drivers/AssignOperatorVehicle'
import * as actions from '../../state/actions/vehicles/'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<any>) {
  const vehiclesAndCount =
    state.vehicles && state.vehicles.items && state.vehicles.items.result
      ? { vehicles: Object.values(state.vehicles.items.result), totalCount: state.vehicles.items.count }
      : { vehicles: null, totalCount: 0 }
  return {
    operatorId: ownProps.match.params.operatorId,
    currentOrganizationId: state.organizations.currentOrgId,
    vehicles: vehiclesAndCount.vehicles,
    filters: state.vehicles.filters,
    onClose: ownProps.history.goBack
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    fetchAllVehicles: (params: IVehicleFilters) => {
      dispatch(actions.getVehicles(params))
    },
    assignDriver: (vehicleId: string, operatorId: string, params: IVehicleFilters) => {
      return dispatch(actions.assignDriver(vehicleId, operatorId, params))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignOperatorVehicle)



// WEBPACK FOOTER //
// ./src/containers/drivers/AssignOperatorVehicle.ts